import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "position-relative d-inline-flex flex-column" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      class: _normalizeClass(["c-button-pill", _ctx.toggleClass]),
      onClick: _cache[0] || (_cache[0] = (...args) => (_ctx.toggle && _ctx.toggle(...args)))
    }, [
      _renderSlot(_ctx.$slots, "button")
    ], 2 /* CLASS */),
    (_ctx.open)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          ref: "dropdown",
          class: _normalizeClass(["c-dropdown position-absolute top-100 z-1", {
        'start-50 translate-middle-x': _ctx.$props.drop === 'center',
        'end-0': _ctx.$props.drop === 'right',
      }])
        }, [
          _renderSlot(_ctx.$slots, "default")
        ], 2 /* CLASS */))
      : _createCommentVNode("v-if", true)
  ]))
}